// extracted by mini-css-extract-plugin
export var clauseRow = "_fp-6";
export var emptyState = "_fp-d";
export var filterContent = "_fp-a";
export var filterGroup = "_fp-1";
export var filterGroupContainer = "_fp-0";
export var nestedGroup = "_fp-2";
export var nestedGroupContent = "_fp-b";
export var nestedGroupDepth1 = "_fp-3";
export var nestedGroupDepth2 = "_fp-4";
export var nestedGroupDepth3 = "_fp-5";
export var nestedGroupEmpty = "_fp-c";
export var operatorAnd = "_fp-8";
export var operatorOr = "_fp-9";
export var operatorToggle = "_fp-7";
export var removeGroupButton = "_fp-e";